import { type TTlds, type BaseJsonConfiguration } from '@dhl/receiver-config'

export const accountTlds = ['nl', 'be', 'eu', 'cz'] as const
export type AccountTlds = typeof accountTlds

export type AccountAppConfiguration = {
  basePath: string
  datadog: {
    applicationId: string
    clientToken: string
    service: string
    logsSessionSampleRate: number
    rumSessionSampleRate: number
    rumSessionReplaySampleRate: number
  }
  gtm: {
    id: string
  }
  oneTrust: {
    id: string
    enableForNative: boolean
    enableForNativeFromVersion: string
  }
  features: {
    recaptcha: {
      active: boolean
      siteKey: string
      enableForNativeFromVersion: string
    }
    signIn: {
      active: boolean
      background: string
      redirectUrl: string
      businessOnboardingButton: {
        active: boolean
      }
      businessOnboardingLink: {
        active: boolean
      }
      c2cButton: {
        active: boolean
      }
    }
    signUp: {
      active: boolean
      background: string
    }
  }
  util: {
    tldOverride?: string
  }
}
export type JsonConfiguration<
  TSupportedTlds extends TTlds,
  TAppConfiguration = AccountAppConfiguration,
> = BaseJsonConfiguration<TSupportedTlds, TAppConfiguration> & {
  BASE_PATH: string
}
